import React from 'react';
import { Switch } from 'antd';

interface SwitchInputProps {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

export const SwitchInput: React.FC<SwitchInputProps> = ({
  checked,
  disabled,
  onChange,
}) => {
  const handleChange = (checked: boolean) => {
    onChange(checked);
  };

  return (
    <Switch checked={checked} onChange={handleChange} disabled={disabled} />
  );
};
